import { render, staticRenderFns } from "./Theclub2Promo.vue?vue&type=template&id=2d042033&scoped=true"
import script from "./Theclub2Promo.vue?vue&type=script&lang=js"
export * from "./Theclub2Promo.vue?vue&type=script&lang=js"
import style0 from "./Theclub2Promo.vue?vue&type=style&index=0&id=2d042033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d042033",
  null
  
)

export default component.exports